import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const DotsIcon = createIcon({
  displayName: 'DotsIcon',
  d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  defaultProps: defaultProps
})
